import { app } from '../../../core/App';
import { Sounds } from '../../../sounds';
import CharacterSpine from '../CharacterSpine';
import { EquipmentType } from '../VehicleEquipment';
import { VehicleEquipmentProjectileWeapon } from '../VehicleEquipmentProjectileWeapon';
import { VehicleVillain } from '../VehicleVillain';
import { ObstacleQuestionCloud } from '../../level/entities/obstacle/ObstacleQuestionCloud';

export class VehicleWeaponSkyWriting extends VehicleEquipmentProjectileWeapon {
  constructor(scene: Phaser.Scene, vehicle: VehicleVillain, camera: Phaser.Cameras.Scene2D.Camera, spine: CharacterSpine) {
    super(scene, EquipmentType.SkyWriting, vehicle, camera, spine, ObstacleQuestionCloud);
  }

  public fire(): void {
    let questionCloud = new ObstacleQuestionCloud(this.scene, this.vehicle.x, this.vehicle.y);
    this.vehicle.VehicleDetails.vehicleLayer.add(questionCloud as unknown as Phaser.GameObjects.GameObject);
    this.vehicle.CharacterSpine.fireEquipment();
    questionCloud.onFire();

    this.emit(VehicleWeaponSkyWriting.events.Firing);
    this.onFinishedFiring();
  }

  public onFinishedFiring() {
    this.emit(VehicleWeaponSkyWriting.events.FinishedFiring);
  }
}
